var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "mb-2 mx-n1 mt-n1"
  }, _vm._l(_vm.items, function (_ref) {
    var color = _ref.color,
        title = _ref.title,
        MODEL_NAME = _ref.MODEL_NAME,
        productionText = _ref.productionText,
        percentageProductive = _ref.percentageProductive,
        percentageDefective = _ref.percentageDefective;
    return _c('v-col', {
      key: title,
      staticClass: "pa-1",
      attrs: {
        "cols": "12",
        "md": "4"
      }
    }, [_c('v-card', _vm._b({
      staticClass: "mx-auto mb-n4",
      staticStyle: {
        "z-index": "2"
      },
      attrs: {
        "dark": "",
        "flat": "",
        "rounded": "xl",
        "width": "67%"
      }
    }, 'v-card', {
      color: color
    }, false), [_c('v-card-title', {
      staticClass: "justify-center pa-1 subtitle-1"
    }, [_vm._v(_vm._s(title))])], 1), _c('v-card', _vm._b({
      attrs: {
        "rounded": "lg",
        "flat": ""
      }
    }, 'v-card', {
      loading: _vm.loading
    }, false), [_c('v-card-text', {
      staticClass: "pa-3 pt-6"
    }, [_c('v-row', {
      attrs: {
        "justify": "center"
      }
    }, [_c('v-col', {
      staticClass: "pa-2",
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-progress-circular', {
      attrs: {
        "value": percentageProductive,
        "color": "success",
        "size": "80",
        "width": "5",
        "rotate": "-90"
      }
    }, [_c('v-layout', {
      attrs: {
        "column": "",
        "align-center": ""
      }
    }, [_c('div', {
      staticClass: "mt-1 caption font-weight-bold"
    }, [_vm._v("생산률")]), _c('div', {
      staticClass: "mt-n2 text-h6 font-weight-bold"
    }, [_vm._v(_vm._s(percentageProductive) + "%")])])], 1)], 1), _c('v-col', {
      staticClass: "pa-2",
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-progress-circular', {
      attrs: {
        "value": percentageDefective,
        "color": "error",
        "size": "80",
        "width": "5",
        "rotate": "-90"
      }
    }, [_c('v-layout', {
      attrs: {
        "column": "",
        "align-center": ""
      }
    }, [_c('div', {
      staticClass: "mt-1 caption font-weight-bold"
    }, [_vm._v("불량률")]), _c('div', {
      staticClass: "mt-n2 text-h6 font-weight-bold"
    }, [_vm._v(_vm._s(percentageDefective) + "%")])])], 1)], 1)], 1)], 1)], 1), _c('v-card', {
      staticClass: "mt-2",
      staticStyle: {
        "border-color": "rgba(0, 0, 0, 0.12) !important"
      },
      attrs: {
        "rounded": "lg",
        "outlined": "",
        "color": "transparent"
      }
    }, [_c('v-card-text', {
      staticClass: "pa-3"
    }, [_c('v-row', {
      staticClass: "mx-auto",
      staticStyle: {
        "width": "210px"
      },
      attrs: {
        "no-gutters": "",
        "justify": "space-between"
      }
    }, [_c('v-col', {
      staticClass: "caption",
      attrs: {
        "cols": "4"
      }
    }, [_vm._v("모델명")]), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_vm._v(_vm._s(MODEL_NAME || "-"))])], 1), _c('v-row', {
      staticClass: "mx-auto",
      staticStyle: {
        "width": "210px"
      },
      attrs: {
        "no-gutters": "",
        "justify": "space-between"
      }
    }, [_c('v-col', {
      staticClass: "caption",
      attrs: {
        "cols": "4"
      }
    }, [_vm._v("작업수량")]), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_vm._v(_vm._s(productionText))])], 1)], 1)], 1)], 1);
  }), 1);
}
var staticRenderFns = []

export { render, staticRenderFns }